import React, { useState, useEffect, useRef } from 'react'
import { FiMenu } from 'react-icons/fi'
import CollapsibleSection from '../../components/chat/CollapsibleSection';
import axios from 'axios';
import { ChevronDown, Clock, Download, MessageCircle, Users } from 'lucide-react';
import MarketPlaceFeedNavbar from './MarketPlaceFeedNavbar';
const BASE_URL = process.env.REACT_APP_BASE_URL
const MarketPlaceChat = () => {
    const [messages, setMessages] = useState([]);
    const [activeGroup, setActiveGroup] = useState("")
    const [lab_groups, setLabGroups] = useState([]);
    const [showMembers, setShowMembers] = useState(false)
    const [isUploading, setIsUploading] = useState(false)
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [input, setInput] = useState("");
    const socketRef = useRef(null);
    const messagesEndRef = useRef(null);
    // console.log("The lab groups are:", messages)
    // ---------------- AUTO SCROLL ----------------
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const fetchLabGroups = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/marketplace/university/groups/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "x-api-key": process.env.REACT_APP_X_API_KEY,
                },
            });
            setLabGroups(res?.data || []);
        } catch (error) {
            console.log("Error while getting profiles", error);
            setLabGroups([]);
        }
    };
    useEffect(() => {
        fetchLabGroups();
    }, []);
    useEffect(() => {
    setMessages([]);  // Clear old group messages
}, [activeGroup?.id]);

// socket chat
// socket chat
useEffect(() => {
    if (!activeGroup?.id) return;
    
    const token = localStorage.getItem("access_token");

    const socket = new WebSocket(
        `ws://localhost:8000/ws/marketplace/group_chat/${activeGroup?.id}/?token=${token}`
    );

    socketRef.current = socket;

    socket.onopen = () => {
        console.log("WebSocket connected");
    };

    socket.onmessage = (event) => {
        const data = JSON.parse(event.data);

        // IGNORE empty messages
        if (!data.message && !data.file && data.type !== "history") {
            return;
        }

        if (data.type === "history") {
            if (data.messages.length === 0) {
                setMessages([]);
                return;
            }
            setMessages(
                data.messages.map((msg) => ({
                    id: msg.id,
                    text: msg.message,
                    file: msg.file,
                    sender: msg.message_by,
                    senderInfo: {
                        id: msg.sender?.id,
                        name: msg.sender_profile?.name || msg.sender?.username || "",
                        profile_picture: msg.sender_profile?.profile_picture,
                        email: msg.sender_profile?.email,
                    },
                    time: msg.timestamp,
                }))
            );
            return;
        }

        // Only add if has content
        if (data.message || data.file) {
            setMessages((prev) => [
                ...prev,
                {
                    id: data.id || Date.now(),
                    text: data.message,
                    file: data.file,
                    sender: data.message_by,
                    senderInfo: {
                        id: data.sender?.id,
                        name: data.sender_profile?.name || data.sender?.username || "",
                        profile_picture: data.sender_profile?.profile_picture,
                        email: data.sender_profile?.email,
                    },
                    time: data.timestamp,
                },
            ]);
        }
    };

    socket.onclose = () => {
        console.log("WebSocket disconnected");
    };

    return () => socket.close();
}, [activeGroup?.id]);

    // ---------------- BASE64 ----------------
    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
        });

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setIsUploading(true);

        try {
            const base64 = await toBase64(file);

            socketRef.current?.send(
                JSON.stringify({
                    type: "file",
                    file_data: base64,
                    file_name: file.name,
                })
            );
        } catch (error) {
            console.error("File upload error:", error);
        } finally {
            // ✅ always runs (success or error)
            setIsUploading(false);
        }
    };

    const handleSend = () => {

        if (!input.trim()) return;

        socketRef.current?.send(
            JSON.stringify({
                type: "text",
                message: input,
            })
        );

        setInput("");
    };

    return (
   <>
   <MarketPlaceFeedNavbar/>
     <div className="flex flex-col h-screen">
    <div className="flex-1 flex overflow-hidden">
        {/* Chat Sidebar */}
        <div
            className={`fixed md:static top-30 left-0 h-full w-full max-w-[350px] border-r border-gray-100 p-4 min-h-full overflow-y-auto bg-white z-50 transform transition-transform duration-300 ${
                isSidebarOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"
            }`}
        >
            {/* Close button for mobile only */}
            <button 
                className="md:hidden absolute top-4 right-4 p-2 text-gray-500 hover:bg-gray-100 rounded-lg transition-colors"
                onClick={() => setIsSidebarOpen(false)}
            >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
            
            <div className="mb-8">
                <div className="conversation-list group-list">
                    <CollapsibleSection title="Groups" defaultOpen={true}>
                        <div className="space-y-1 mt-2">
                            {lab_groups.map((group) => (
                                <div
                                    key={group.id || group.conversationId}
                                    className={`flex items-center p-3 rounded-xl cursor-pointer transition-all duration-200 ${activeGroup?.id === group?.id
                                        ? "bg-[#e8f0f7] ring-1 ring-[#0f6abf]/20"
                                        : "hover:bg-gray-50"
                                        }`}
                                    onClick={() => {
                                        setActiveGroup(group);
                                        setIsSidebarOpen(false); // Close sidebar on mobile after selection
                                    }}
                                >
                                    <div className="relative flex-shrink-0">
                                        <img
                                            src={group?.group_logo}
                                            className="w-10 h-10 rounded-lg object-cover ring-gray-100"
                                            alt={group?.group_name}
                                        />
                                    </div>
                                    <div className="ml-3 flex-1 min-w-0">
                                        <h4 className="font-medium text-sm text-gray-900 truncate">{group?.group_name}</h4>
                                        <p className="text-xs text-gray-500 truncate">Group • {group?.member_data?.length + 1 || 0} members</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </CollapsibleSection>
                </div>
            </div>
        </div>
        
        {/* Main Chat */}
        <div className="flex-1 flex flex-col bg-white">
            {/* Mobile Hamburger Button - Only shows when sidebar is closed on mobile */}
            {!isSidebarOpen && (
                <button 
                    className="md:hidden fixed top-4 left-4 z-40 p-2 bg-white rounded-lg shadow-md border border-gray-200"
                    onClick={() => setIsSidebarOpen(true)}
                >
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
            )}

            {activeGroup && activeGroup.id ? (
                <>
                    {/* Chat Header */}
                    <div className="w-full p-3 md:p-4 border-b border-gray-100 rounded-tr-[10px] bg-white">
                        <div className="flex items-center justify-between">
                            {/* Left Side: User/Group Info */}
                            <div className="flex items-center gap-2 md:gap-3 flex-1 min-w-0">
                                <div className="relative flex-shrink-0">
                                    <img
                                        src={
                                            activeGroup.group_logo ||
                                            activeGroup.profile_image
                                        }
                                        className="w-10 h-10 md:w-12 md:h-12 rounded-lg md:rounded-xl object-cover ring-2 ring-white shadow-sm"
                                        alt={activeGroup.group_name}
                                    />
                                </div>
                                <div className="flex flex-col flex-1 min-w-0">
                                    <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
                                        <div>
                                            <h3 className="font-semibold text-gray-900 text-sm md:text-base truncate">
                                                {activeGroup?.group_name}
                                            </h3>
                                        </div>
                                        {activeGroup && (
                                            <div className="relative flex-shrink-0">
                                                {/* Desktop Version */}
                                                <div className="hidden md:block">
                                                    <button
                                                        className="flex items-center gap-1.5 px-3 py-1.5 bg-[#e8f0f7] text-[#0f6abf] text-sm font-medium rounded-lg hover:bg-[#d0e0f0] transition-colors whitespace-nowrap"
                                                        onClick={() => setShowMembers(!showMembers)}
                                                    >
                                                        <Users size={14} />
                                                        <span>{activeGroup?.member_data?.length + 1} members</span>
                                                        <ChevronDown
                                                            size={14}
                                                            className={`transition-transform ${showMembers ? 'rotate-180' : ''}`}
                                                        />
                                                    </button>
                                                </div>

                                                {/* Mobile Version - Simplified */}
                                                <div className="md:hidden">
                                                    <button
                                                        className="flex items-center gap-1 px-2 py-1 bg-[#e8f0f7] text-[#0f6abf] text-xs font-medium rounded-lg hover:bg-[#d0e0f0] transition-colors whitespace-nowrap"
                                                        onClick={() => setShowMembers(!showMembers)}
                                                    >
                                                        <Users size={12} />
                                                        <span>{activeGroup?.member_data?.length + 1}</span>
                                                    </button>
                                                </div>

                                                {/* Members Dropdown */}
                                                {showMembers && (
                                                    <div
                                                        className="absolute top-full left-0 md:left-auto md:right-0 mt-2 bg-white rounded-lg md:rounded-xl shadow-lg border border-gray-200 w-full md:w-64 max-h-60 md:max-h-80 overflow-y-auto z-50"
                                                    >
                                                        <div className="p-2 md:p-3 border-b border-gray-100">
                                                            <h4 className="font-semibold text-gray-900 text-sm">Group Owner or Creator</h4>
                                                        </div>
                                                        <div className="flex items-center justify-between p-2 rounded-lg hover:bg-gray-50 transition-colors">
                                                            <div className="flex items-center gap-2 flex-1 min-w-0">
                                                                <img
                                                                    src={activeGroup?.labhead_or_owner_data?.profile_data?.profile_picture}
                                                                    alt={activeGroup?.labhead_or_owner_data?.profile_data?.name}
                                                                    className="w-7 h-7 md:w-8 md:h-8 rounded-full object-cover"
                                                                />
                                                                <div className="flex-1 min-w-0">
                                                                    <div className="flex flex-col md:flex-row md:items-center gap-0.5 md:gap-1.5">
                                                                        <span className="text-xs md:text-sm font-medium text-gray-900 truncate">
                                                                            {activeGroup?.labhead_or_owner_data?.profile_data?.name}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="p-2 md:p-3 border-b border-gray-100">
                                                            <h4 className="font-semibold text-gray-900 text-sm">Group Members</h4>
                                                            <p className="text-xs text-gray-500 mt-0.5">{activeGroup?.member_data?.length} total members</p>
                                                        </div>

                                                        <div className="p-1 md:p-2">
                                                            {activeGroup?.member_data?.map((m) => (
                                                                <div key={m?.profile_data?.id} className="flex items-center justify-between p-2 rounded-lg hover:bg-gray-50 transition-colors">
                                                                    <div className="flex items-center gap-2 flex-1 min-w-0">
                                                                        <img
                                                                            src={m?.profile_data?.profile_picture}
                                                                            alt={m?.profile_data?.name}
                                                                            className="w-7 h-7 md:w-8 md:h-8 rounded-full object-cover"
                                                                        />
                                                                        <div className="flex-1 min-w-0">
                                                                            <div className="flex flex-col md:flex-row md:items-center gap-0.5 md:gap-1.5">
                                                                                <span className="text-xs md:text-sm font-medium text-gray-900 truncate">
                                                                                    {m?.profile_data?.name}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    {activeGroup && (
                                        <p className="text-xs text-gray-500 mt-0.5 hidden md:block">
                                            Group • Last active recently
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Chat container */}
                    <div className="flex-1 p-2.5 px-5 overflow-y-auto bg-gray-50 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
                        <div className="space-y-2.5">
                            {messages.length === 0 ? (
                                <div className="flex flex-col items-center justify-center h-full py-12">
                                    <div className="w-16 h-16 rounded-full bg-[#e8f0f7] flex items-center justify-center mb-4">
                                        <svg className="w-8 h-8 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0 4.418 4.03-8 9-8s9 3.582 9 8z" />
                                        </svg>
                                    </div>
                                    <h3 className="text-lg font-semibold text-[#686868] mb-2">No messages yet</h3>
                                    <p className="text-sm text-[#797979] text-center max-w-md">
                                        Start the conversation by sending your first message
                                    </p>
                                </div>
                            ) : (
                                messages.map((msg, idx) => {
                                    return (
                                        <div key={idx} className="space-y-1">
                                            <div className={`flex items-center gap-2 mb-1 ${msg.sender === "me" ? "justify-end" : "justify-start"}`}>
                                                {msg.sender !== "me" && msg.senderInfo?.name && (
                                                    <>
                                                        {msg.senderInfo?.profile_picture ? (
                                                            <img 
                                                                src={msg.senderInfo.profile_picture} 
                                                                alt={msg.senderInfo.name}
                                                                className="w-7 h-7 rounded-full object-cover border-2 border-white shadow-sm"
                                                            />
                                                        ) : (
                                                            <div className="w-7 h-7 rounded-full bg-[#e8f0f7] flex items-center justify-center text-xs font-medium text-[#0f6abf]">
                                                                {msg.senderInfo.name.charAt(0)}
                                                            </div>
                                                        )}
                                                        <span className="text-xs font-medium text-gray-700">
                                                            {msg.senderInfo.name}
                                                        </span>
                                                    </>
                                                )}
                                                {msg.sender === "me" && (
                                                    <div className="flex items-center gap-2">
                                                        <span className="text-xs font-medium text-gray-700">You</span>
                                                        {msg.senderInfo?.profile_picture && (
                                                            <img 
                                                                src={msg.senderInfo.profile_picture} 
                                                                alt="You"
                                                                className="w-7 h-7 rounded-full object-cover border-2 border-white shadow-sm"
                                                            />
                                                        )}
                                                    </div>
                                                )}
                                            </div>

                                            <div
                                                className={`max-w-[75%] px-4 py-2.5 rounded-xl text-sm ${
                                                    msg.sender === "me"
                                                        ? "bg-[#0f6abf] text-white ml-auto rounded-br-sm"
                                                        : "bg-white text-gray-900 border border-gray-200 rounded-bl-sm shadow-sm"
                                                }`}
                                            >
                                                {msg.text && <div className="break-words">{msg.text}</div>}
                                                {msg.file && (
                                                    <div className="relative w-full rounded-md overflow-hidden">
                                                        <iframe
                                                            src={msg.file}
                                                            className="w-full h-60"
                                                            title="File preview"
                                                        />
                                                        <div className="absolute bottom-2 right-2 bg-white rounded-full p-1 shadow-md cursor-pointer hover:bg-gray-100">
                                                            <Download
                                                                className="w-5 h-5 text-blue-500"
                                                                onClick={() => window.open(msg.file, "_blank")}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                                {msg.time && (
                                                    <div className={`text-[10px] mt-1.5 ${msg.sender === "me" ? "text-white/70" : "text-gray-400"}`}>
                                                        {msg.time}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                        <div ref={messagesEndRef} />
                    </div>
                    {/* Chat Input */}
                    <div className="p-4 border-t border-gray-100 bg-white rounded-br-[10px] ">
                        <form className="flex items-center gap-2" onSubmit={(e) => {
                            e.preventDefault();
                            handleSend();
                        }} >
                            <div className="flex-1 relative">
                                <input
                                    type="text"
                                    name="messageInput"
                                    value={input}
                                    onChange={(e) => setInput(e.target.value)}
                                    placeholder="Type a message..."
                                    disabled={!activeGroup}
                                    className={`w-full px-5 py-3 text-gray-900 rounded-xl border transition-all duration-200 ${activeGroup
                                        ? "border-gray-300 bg-white focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 focus:outline-none hover:border-gray-400"
                                        : "border-gray-200 bg-gray-50/50 text-gray-500 cursor-not-allowed"
                                        }`}
                                />

                                {/* Attachment Button */}
                                {activeGroup && (
                                    <>
                                        <label
                                            htmlFor="file-upload"
                                            className={`absolute right-3 top-1/2 -translate-y-1/2 p-1.5 transition-colors ${isUploading
                                                ? "text-gray-400 cursor-not-allowed"
                                                : "text-gray-400 hover:text-gray-600 cursor-pointer"
                                                }`}
                                            title={isUploading ? "Uploading..." : "Add attachment"}
                                        >
                                            {isUploading ? (
                                                <div className="w-5 h-5 border-2 border-[#0f6abf] border-t-transparent rounded-full animate-spin"></div>
                                            ) : (
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                                                </svg>
                                            )}
                                        </label>
                                        <input
                                            id="file-upload"
                                            type="file"
                                            className="hidden"
                                            onChange={handleFileChange}
                                            disabled={isUploading || !activeGroup}
                                        />
                                    </>
                                )}
                            </div>

                            <button
                                className={`flex items-center justify-center px-5 py-3 rounded-xl font-medium transition-all duration-200 ${activeGroup
                                    ? "bg-[#0f6abf] text-white hover:bg-[#0a5ca8] active:scale-[0.98]"
                                    : "bg-gray-200 text-gray-400 cursor-not-allowed"
                                    }`}
                                onClick={handleSend}
                                type="submit"
                            >
                                {isUploading ? (
                                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                ) : (
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                                    </svg>
                                )}
                            </button>
                        </form>
                    </div>
                </>
            ) : (
                <div className="flex-1 flex items-center justify-center p-8">
                    <div className="text-center max-w-[280px]">
                        <div className="w-16 h-16 bg-[#e8f0f7] rounded-full flex items-center justify-center mx-auto mb-4">
                            <MessageCircle size={24} className="text-[#0f6abf]" />
                        </div>
                        <h3 className="font-semibold text-gray-800 text-lg mb-2">
                            Start a conversation
                        </h3>
                        <p className="text-gray-500 text-sm">
                            Select group from the sidebar to begin messaging
                        </p>
                    </div>
                </div>
            )}
        </div>
    </div>
</div>
   </>
    )
}

export default MarketPlaceChat
